import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { systemIcons, visualIcons } from "../../icons";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import classNames from "classnames";
const grIcons = {
    ...systemIcons,
    ...visualIcons,
};
const StyledIcon = styled("div")(({ size, color, style }) => {
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: size,
        svg: {
            ...(size && {
                width: size,
                height: size,
            }),
            ...(color && {
                path: {
                    [`&[fill="${palette.grey050}"]`]: {
                        fill: palette[color],
                    },
                },
            }),
        },
        ...style,
    };
});
export function GrIcon({ type, size = 24, color, style, className }) {
    const isVisualIcon = Object.keys(visualIcons).includes(type);
    return (_jsx(StyledIcon, { className: classNames("GrIcon", className), size: size, color: isVisualIcon ? undefined : color, style: style, children: grIcons[type] }));
}
//# sourceMappingURL=GrIcon.js.map